import NudosConfirmActionModal from '../../../../../../components/NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';
import { SWR_KEYS } from '../../../../../../constants/constants';
import { deleteConfiguration } from '../../../../../../services/suscription/configurations.service';
import { displaySuccessNotification } from '../../../../../../utils/displayNudosStandardNotifications';
import useConfigurationGlobalState from '../configurationGlobalState';
import useSWRMutation from 'swr/mutation';
import { IOrganizationConfig } from '../../../../../../types/product.configuration.types';
import './DeleteConfigModal.scss';

const DeleteConfigModal = ({
  closeModalCallback,
  mutateGetOrganizationConfigByOrganizationId
}: {
  closeModalCallback: () => void;
  mutateGetOrganizationConfigByOrganizationId: () => Promise<IOrganizationConfig[] | undefined>;
}) => {
  const { configUnit } = useConfigurationGlobalState();

  const { trigger: deleteConfigurationTrigger, isMutating: isLoadingDeleteConfiguration } = useSWRMutation(
    SWR_KEYS.deleteConfiguration,
    async (
      __,
      {
        arg
      }: {
        arg: {
          uuid: string;
        };
      }
    ) => {
      return await deleteConfiguration(arg.uuid);
    },
    {
      onSuccess: () => {
        closeModalCallback();
        displaySuccessNotification({
          customJSXMessage: <>Configuración se eliminó correctamente </>
        });
        mutateGetOrganizationConfigByOrganizationId();
      }
    }
  );

  return (
    <NudosConfirmActionModal
      modalText={
        <div className="deleteConfigModalText">
          Estás por eliminar la configuración <strong>{configUnit?.name}</strong>. <br /> ¿Seguro que deseas continuar?
        </div>
      }
      firstButtonText="No, cancelar"
      secondButtonText="Sí, eliminar"
      firstButtonAction={closeModalCallback}
      secondButtonAction={() => {
        deleteConfigurationTrigger({ uuid: configUnit?.uuid as string });
      }}
      customHeight="240px"
      isLoading={isLoadingDeleteConfiguration}
    />
  );
};

export default DeleteConfigModal;
